import {useEffect, useState} from 'react';

const ModuleCellRenderer = ({value}) => {
    const [module, setModule] = useState("");
    useEffect(() => {
        let modulePrepared = "";
        try {
            const moduleParsed = JSON.parse(value);
            for (let i = 0; i < moduleParsed.length; i++) {
                if (i === 0) {
                    modulePrepared = moduleParsed[i];
                } else {
                    modulePrepared += ', '+moduleParsed[i];
                }
            }
        } catch (Error) {
            modulePrepared = value;
        }

        setModule(modulePrepared)
    }, [value]);

    return (module);
};

export default ModuleCellRenderer;
